import React, { ReactNode } from 'react';
import { IBenefitType } from '@epi-models/containers/ManageBenefits';
import {
  LunchIcon,
  RecreationalIcon,
  TransportIcon,
  MassageIcon,
  WellbeingIcon,
  Tooltip,
  Box,
  Text
} from 'edenred-ui';
import { TFunction } from 'react-i18next';

export const BenefitType: IBenefitType = {
  Lunch: 'lunch',
  Transport: 'transport',
  Massage: 'massage',
  Wellbeing: 'wellbeing',
  Recreational: 'recreational'
} as const;

export const LUNCH = 'Lunch';
export const RECREATIONAL = 'Recreational';

export const ACTIVE = 'Active';
export const INACTIVE = 'Contracted';
export const READY_TO_ORDER = 'NotContracted';
export const ORDERED = 'Ordered';
export const ON_HOLD = 'Onhold';
export const SELECTED_BENEFIT_PARAM = 'selected-benefit';

export const Schedule = {
  Direct: 'directTopup',
  SelectDate: 'selectDate'
} as const;

export const Payment = {
  EInvoice: 'EInvoice',
  Deduction: 'CompanyAccount'
} as const;

export const getBenefitIcon = (
  t: TFunction<'translation', undefined>,
  type: string,
  color?: string
) => {
  switch (type.toLowerCase()) {
    case BenefitType.Lunch:
      return (
        <BenefitTypeTooltip
          icon={<LunchIcon color={color} />}
          tooltipText={t('home.benefits_tile.lunch.title')}
        />
      );
    case BenefitType.Recreational:
      return (
        <BenefitTypeTooltip
          icon={<RecreationalIcon color={color} />}
          tooltipText={t('home.benefits_tile.recreational.title')}
        />
      );
    case BenefitType.Transport:
      return (
        <BenefitTypeTooltip
          icon={<TransportIcon color={color} />}
          tooltipText={t('home.benefits_tile.transport.title')}
        />
      );
    case BenefitType.Massage:
      return (
        <BenefitTypeTooltip
          icon={<MassageIcon color={color} />}
          tooltipText={t('home.benefits_tile.massage.title')}
        />
      );
    case BenefitType.Wellbeing:
      return (
        <BenefitTypeTooltip
          icon={<WellbeingIcon color={color} />}
          tooltipText={t('home.benefits_tile.wellbeing.title')}
        />
      );
    default:
      return;
  }
};

export const FundsLoadingTypes = {
  TopUpRequest: 'TopUpRequest',
  DirectLoad: 'DirectLoad'
} as const;

export const LimitType = {
  maximum: 'maximum',
  custom: 'custom'
};

export const myChoiceBenefits = [
  BenefitType.Transport,
  BenefitType.Massage,
  BenefitType.Recreational,
  BenefitType.Wellbeing,
  BenefitType.Lunch
];

interface IBenefitTypeTooltip {
  icon: ReactNode;
  tooltipText: string;
}

export const BenefitTypeTooltip = ({
  icon,
  tooltipText
}: IBenefitTypeTooltip) => {
  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <Box pr={1}>
          <Text small>{tooltipText}</Text>
        </Box>
      }
    >
      <Box display="inline-block">{icon}</Box>
    </Tooltip>
  );
};
